import { render, staticRenderFns } from "./LandSuitabilityDetailReport.vue?vue&type=template&id=bae885ae&scoped=true"
import script from "./LandSuitabilityDetailReport.vue?vue&type=script&lang=js"
export * from "./LandSuitabilityDetailReport.vue?vue&type=script&lang=js"
import style0 from "./LandSuitabilityDetailReport.vue?vue&type=style&index=0&id=bae885ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae885ae",
  null
  
)

export default component.exports